import SearchableSelect from '../../../../components/ui/SearchableSelect/SearchableSelect';
import { SELECT_MODE } from '../../../../components/ui/SearchableSelect/constants';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function TemplateSearchableSelect({
  sx,
  slotProps,
  variant = 'form',
  ...props
}) {
  const styles = useTemplateSx();
  const controlStyle = variant === 'filter' ? styles.filterControl : styles.formSelectControl;

  return (
    <SearchableSelect
      {...props}
      shrinkLabel
      mode={props.mode || SELECT_MODE.STATIC}
      size={props.size || 'small'}
      sx={{ ...controlStyle, ...sx }}
      slotProps={{
        paper: { sx: { mt: 0.5, borderRadius: 2 } },
        ...slotProps,
      }}
    />
  );
}
